export async function makeRestCall(baseURL, urlSelected, languageSelected) {
    try {
        const resp = await fetch(`${baseURL}api/v1/getdata?table=${urlSelected}${languageSelected}`, {
            method: 'GET',
        });
        const response = await resp.json();
        const filteredData = response.filter(item => item.deleted_at === null);
        const uniqueCities = [...new Set(response.map(item => item.comune))];
        return { filteredData, uniqueCities };
    } catch (error) {
        console.log("Errore nella richiesta", error);
        return { filteredData: [], uniqueCities: [] };
    }
}